import React, { useCallback, useMemo } from "react";
import { Input, notification } from "antd";
import classes from "./zapier-result-box.module.scss";
import copy from "copy-to-clipboard";
import classNames from "classnames";
import { useDispatch, useSelector } from "react-redux";
import {
  selectActiveDetectedFieldId,
  selectActiveObjectId,
} from "../../../../../reducers/editor/selectors";
import {
  selectPage,
  selectTotalPages,
} from "../../../../../reducers/pdf-viewer/selectors";
import { setPdfPage } from "../../../../../reducers/pdf-viewer/actions";
import { OBJECT_TYPES } from "../../../../../constants/project";
import {
  setActiveDetectedField,
  setActiveObjectId,
} from "../../../../../reducers/editor/actions";
import {
  getZapierFieldData,
  getZapierImageData,
  getZapierTextData,
} from "../../../../../helpers/objects";

const { TextArea } = Input;

const ResultBox = ({ data, boxClass }) => {
  const dispatch = useDispatch();
  const activeObjectId = useSelector(selectActiveObjectId);
  const activeDetectedFieldId = useSelector(selectActiveDetectedFieldId);
  const totalPages = useSelector(selectTotalPages);
  const currentPage = useSelector(selectPage);

  const annotations = useMemo(() => {
    return data
      .filter((item) => item.objectType === OBJECT_TYPES.ANNOTATION)
      .map((item) => {
        return { ...item, showData: getZapierTextData(item) };
      });
  }, [data]);

  const images = useMemo(() => {
    return data
      .filter((item) => item.objectType === OBJECT_TYPES.IMAGE)
      .map((item) => {
        return { ...item, showData: getZapierImageData(item) };
      });
  }, [data]);

  const fields = useMemo(() => {
    return data
      .filter((item) => item.objectType === OBJECT_TYPES.DETECTED_FIELD)
      .map((item) => {
        return { ...item, showData: getZapierFieldData(item) };
      });
  }, [data]);

  const onClickItem = (item) => {
    const page = Number(item.pages) + 1;
    if (page !== currentPage && page <= totalPages) {
      dispatch(setPdfPage(page));
    }
    if (item.objectType === OBJECT_TYPES.DETECTED_FIELD) {
      dispatch(setActiveDetectedField(item.objectId ? item.objectId : item.id));
    } else {
      dispatch(setActiveObjectId(item.objectId));
    }
  };

  const isActive = useCallback(
    (item) => {
      if (item.objectType === OBJECT_TYPES.DETECTED_FIELD) {
        return item.objectId
          ? activeDetectedFieldId === item.objectId
          : activeDetectedFieldId === item.id;
      }
      return activeObjectId === item.objectId;
    },
    [activeObjectId, activeDetectedFieldId]
  );

  const onCopyItem = (item) => {
    copy(item);
    notification.success({
      message: "Copied!",
    });
  };

  const ShowItem = ({ item, key }) => {
    return (
      <div
        key={key}
        className={classNames(classes.ListItem, {
          [classes.ActiveObject]: isActive(item),
        })}
        onClick={() => {
          onClickItem(item);
        }}
      >
        <div className={classes.ItemValue}>{item.showData}</div>
        <div>
          <button
            className={classNames(classes.CopyItemIcon, "btn btn-primary")}
            onClick={() => onCopyItem(item.showData)}
          >
            Copy
          </button>
          {/*<Tooltip title="Copy">*/}
          {/*  <FontAwesomeIcon*/}
          {/*    className={classNames(classes.CopyItemIcon, "text-primary")}*/}
          {/*    icon={faCopy}*/}
          {/*    onClick={() => onCopyItem(item.showData)}*/}
          {/*  />*/}
          {/*</Tooltip>*/}
        </div>
      </div>
    );
  };

  return (
    <div className={classNames(classes.BoxWrap, boxClass)}>
      {data ? (
        <div className={classNames(classes.ListWrap)}>
          {!!annotations.length && (
            <>
              <div className="ms-1 fw-bold text-primary">Text objects</div>
              {annotations.map((item, index) => (
                <ShowItem item={item} key={index} />
              ))}
            </>
          )}

          {!!images.length && (
            <>
              <div className="ms-1 fw-bold text-primary  mt-2">
                Image objects
              </div>
              {images.map((item, index) => (
                <ShowItem item={item} key={index} />
              ))}
            </>
          )}

          {!!fields.length && (
            <>
              <div className="ms-1 fw-bold text-primary mt-2">
                Field objects
              </div>
              {fields.map((item, index) => (
                <ShowItem item={item} key={index} />
              ))}
            </>
          )}
        </div>
      ) : (
        <TextArea value={data} className={classes.TextArea} />
      )}
    </div>
  );
};

export default ResultBox;
